import React from 'react';
import { Card } from './ui/card';

export const BrandStory = () => {
  return (
    <section className="py-24 bg-[#FAF9F7]">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center max-w-6xl mx-auto">
          {/* Left Content */}
          <div>
            <p className="text-[#8B7D6B] font-montserrat text-sm tracking-[0.2em] uppercase mb-4">
              Our Heritage
            </p>
            <h2 className="text-4xl md:text-5xl font-seasons font-light text-[#2C2C2C] mb-6 leading-tight">
              Four Decades of
              <br />
              Crafting Elegance
            </h2>
            <div className="space-y-6 text-[#8B7D6B] font-montserrat leading-relaxed">
              <p>
                Since 1985, Sachdeva Sons has been synonymous with exquisite Indian ethnic wear. What began as a small family venture has blossomed into a destination for women seeking timeless elegance and impeccable craftsmanship.
              </p>
              <p>
                Our journey is rooted in a deep appreciation for traditional Indian artistry. We work closely with master craftsmen and weavers across India, ensuring that every piece in our collection tells a story of heritage, skill, and passion.
              </p>
              <p>
                Today, we blend centuries-old techniques with contemporary design sensibilities, creating ethnic wear that honors tradition while embracing modern aesthetics. Each garment is a testament to our commitment to quality, authenticity, and the celebration of Indian craftsmanship.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-12 pt-8 border-t border-[#D4C4B0]">
              <div>
                <p className="text-3xl font-seasons font-light text-[#6B4E37] mb-1">40+</p>
                <p className="text-xs font-montserrat text-[#8B7D6B] tracking-wide uppercase">Years</p>
              </div>
              <div>
                <p className="text-3xl font-seasons font-light text-[#6B4E37] mb-1">50+</p>
                <p className="text-xs font-montserrat text-[#8B7D6B] tracking-wide uppercase">Artisans</p>
              </div>
              <div>
                <p className="text-3xl font-seasons font-light text-[#6B4E37] mb-1">25K+</p>
                <p className="text-xs font-montserrat text-[#8B7D6B] tracking-wide uppercase">Customers</p>
              </div>
            </div>
          </div>

          {/* Right Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <Card className="overflow-hidden border-none shadow-lg">
              <img
                src="https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/pr6y97xh_8A0A482A-1208-41D3-A02F-CC70B68ABFCD.png"
                alt="Ethnic craftsmanship"
                className="w-full h-64 object-cover"
              />
            </Card>
            <Card className="overflow-hidden border-none shadow-lg mt-8">
              <img
                src="https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ceavocb0_IMG_0408.jpeg"
                alt="Traditional designs"
                className="w-full h-64 object-cover"
              />
            </Card>
            <Card className="overflow-hidden border-none shadow-lg -mt-8">
              <img
                src="https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/yavwv10g_IMG_0030.jpeg"
                alt="Elegant sarees"
                className="w-full h-64 object-cover"
              />
            </Card>
            <Card className="overflow-hidden border-none shadow-lg">
              <img
                src="https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/iez6hk7j_IMG_0179.jpeg"
                alt="Quality fabrics"
                className="w-full h-64 object-cover"
              />
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};